<template>
    <!-- 预约管理 -->
    <div class="main course">
        <Calendar ref="Calendar" :sundayStart="true" :markDate="arr" v-on:choseDay="clickDay" v-on:changeMonth="changeDate"></Calendar>
        <div class="course-container">
            <!-- <class-card v-bind:item="classInfo"></class-card> -->
            <reserved-card-manage v-for="item in classInfos" :key="item.id" :item="item"></reserved-card-manage>         
        </div>
        <!-- <van-popup v-model="show" position="bottom">
          <van-nav-bar
            :title="onclickDay"
            left-text="取消"
            right-text="确定预约"
            @click-left="show = false"
            @click-right="onClickRight"
          />
          <van-picker :columns="columns" @change="onChange" />
        </van-popup> -->
        <the-tabbar></the-tabbar>
    </div>
</template>
<script>
import Vue from 'vue';
import { Field,Button,Toast,Popup,NavBar,Picker } from 'vant';
import TheTabbar from '@/components/TheTabbar';
import ReservedCardManage from '@/components/ReservedCardManage';
import TheCopyright from '@/components/TheCopyright';
import AppointmentCard from '@/components/AppointmentCard';
import ClassCard from '@/components/ClassCard';
import Calendar from '@/components/calendar-component/index';
import moment from 'moment';
import Func from "@/assets/scripts/func";
moment.locale('zh-cn');

Vue.use(Field).use(Button).use(Toast).use(Popup).use(NavBar).use(Picker);

export default {
    name: 'CourseClassManage',
    components: {
        TheTabbar,TheCopyright,Calendar,AppointmentCard,ClassCard,ReservedCardManage
    },
    data(){
        return {
            arr: [],            
            show: false,  // 新预约层
            columns: [
              { text: '9:00 - 10:00', disabled: true},
              { text: '10:00 - 11:00'},
              { text: '11:00 - 12:00'},
              { text: '12:00 - 13:00'},
              { text: '13:00 - 14:00'},
              { text: '14:00 - 15:00'},
            ],  // 预约时间段
            onclickDay: moment(new Date()).format('YYYY年MM月DD日'),//默认日期今天
            classInfos:[],
            month: moment(new Date()).format('YYYYMM')
        }
    },
    created(){      
      this.$options.methods.getData.bind(this)();  //调用methods方法
    },
    methods: {
      getData(){
        //通用 调取接口
        this.$http.post('club_user_reserve_manage/getDayList',{
          dayType: 'month',
          month:this.month
        }).then(res => {
          for(var tmp in res.data.value){
            this.arr.push(tmp); //课程日期
          }

          // 课程(当月有课程的日期)
          if(this.arr!=''){
            this.$http.post('club_user_reserve_manage/getReserveList',{
              date: this.arr[0]
            }).then(ress => {
              this.classInfos = ress.data.value;
            }) 
          }                      
        })
      },
      clickDay(data) {
        // 点击天
        var odata = moment(data).format('YYYY/MM/DD');  //转换日期格式        
        this.classInfos = [];   //课程信息清空
        //点击切换课程信息
        this.$http.post('club_user_reserve_manage/getReserveList',{
          date: odata
        }).then(res => {
          this.classInfos = res.data.value;
        })         
      },
      changeDate(data) {
        // 切换月份
        this.month = moment(data).format('YYYYMM');  //月份赋值
        this.arr = [];   //课程日期清空
        this.classInfos = [];   //课程信息清空
       
        this.$options.methods.getData.bind(this)();  //调用methods方法
      },
      demo() {
        //验证是否登录
        if (!Func.isSetCookie('_ibl')) {
          // this.$router.push({ name: 'login', query: { redirect: location.href }})
          location.href = `${location.origin}/m/login?redirect=${encodeURIComponent(location.href)}`
          return
        }
        this.show = true;
      },
      onClickRight() {
        Toast('预约成功');
        this.show = false;
      },
      onChange(picker, value, index) {
        Toast(`当前值：${value}, 当前索引：${index}`);
      }
  }
}
</script>
<style lang="less" scoped>
.course-container{
  padding: 0 .15rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/CourseClassManage.vue